// src/axiosConfig.js
import axios from 'axios';
import VueCookies from 'vue-cookies';

// Configuration de l'URL de base du backend
axios.defaults.baseURL = 'https://simef.fr/espace-client';

const token = VueCookies.get('token');
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

export default axios;